<zainergy-dashboard-cards for="{{kpi}}"></zainergy-dashboard-cards>